import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlassian/wac-ufo-segment";

import { parseRoute } from "../../../wac-routes";

import { GlobalFooterBottom } from "./global-footer-bottom";
import { GlobalFooterTop } from "./global-footer-top";

// ==================================================================
// CSS styling
// ==================================================================
const globalFooterStyle = css({
    backgroundColor: "#f4f5f7",
    padding: "16px 0 0 0",
    position: "relative",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%",
    clear: "both"
});

// ==================================================================
// Type Props
// ==================================================================
export type GlobalFooterPatternProps = {
    selectedLanguage?: string;
    onLanguageChangeHandler?: React.Dispatch<string>;
};

// ==================================================================
// Rendering Functions
// ==================================================================
export const GlobalFooter = ({
    selectedLanguage,
    onLanguageChangeHandler
}: GlobalFooterPatternProps) => {
    const intl = useIntl();

    if (!selectedLanguage) {
        selectedLanguage = intl.locale || "en";
    }

    if (!onLanguageChangeHandler) {
        onLanguageChangeHandler = (newLocale) => {
            // check if there is already a locale in the path
            const { path } = parseRoute(window.location);

            // exclude trailing slash in the case of the home page
            window.location.href = path.length
                ? `/${newLocale}/${path}`
                : `/${newLocale}`;
        };
    }

    return (
        <UFOSegment name="global-footer">
            <footer css={globalFooterStyle}>
                <GlobalFooterTop />
                <GlobalFooterBottom
                    selectedLanguage={selectedLanguage}
                    onLanguageChangeHandler={onLanguageChangeHandler}
                />
            </footer>
        </UFOSegment>
    );
};
